const MOBILE_USER_AGENT_PATTERN =
  /(ipod|ipad|iphone|android|adr|mobile|harmonyos|openharmony|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i;

export function isMobile(userAgent = navigator.userAgent) {
  return MOBILE_USER_AGENT_PATTERN.test(userAgent);
}

export function isAndroid(userAgent = navigator.userAgent) {
  return /(android|adr)/i.test(userAgent);
}
